<mat-dialog-content class="mat-typography">
    <form [formGroup]="Form" class="example-form">

        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" required>
            <!-- <mat-error *ngIf="f.name.invalid">Please enter a name</mat-error> -->
        </mat-form-field>

        
        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Select Organization</mat-label>
            <mat-select formControlName="orgId">
              <mat-option *ngFor="let item of organizationData" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>

        <mat-slide-toggle color="primary" formControlName="active">Active</mat-slide-toggle>

    
    </form>  
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <div class="formFooter">
        <button mat-raised-button color="primary" (click)="onSubmit()">Submit</button>
    </div>
</mat-dialog-actions>
